import React, { forwardRef, useContext } from 'react'
import styled from 'styled-components'
import HeaderBar from './HeaderBar'
import zIndex from 'styles/tools/z-index'
import { mediaQueryUp } from 'components/utils/breakpoint'
import cn from 'clsx'
import useScrollDirection from 'hooks/useScrollDirection'
import { HeaderHeightContext } from 'contexts/HeaderStateContext'
import { useIsMobileScreen } from 'lib/web/deviceUtils'

const HeaderBarStyled = styled(HeaderBar)`
  position: sticky;
  top: var(--top-offset, 0);
  transform: translateY(0);
  transition: box-shadow 0.2s;
  z-index: ${zIndex.stickyHeader};

  &.elevated {
    box-shadow: ${(props) => props.theme.shadow.bottom.small};
    transition: transform 0.2s, box-shadow 0.2s;

    &.mobile-hidden {
      transform: translateY(-100%);
    }
  }

  ${mediaQueryUp.tablet} {
    top: 0;

    &.elevated.mobile-hidden {
      transform: unset;
    }
  }
`

interface Props {
  shouldAppearOnScrollUp?: boolean
}

const StickyHeaderBar = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { shouldAppearOnScrollUp } = props
  const watchDirection = useIsMobileScreen()
  const direction = useScrollDirection({ tolerance: 10, disabled: !watchDirection })
  const { heights } = useContext(HeaderHeightContext)

  return <HeaderBarStyled
    ref={ref}
    className={cn({
      elevated: shouldAppearOnScrollUp,
      'mobile-hidden': direction === 'down',
    })}
    style={{ ['--top-offset' as string]: `${heights.siteStickyBanner}px` }}
  />
})

export default StickyHeaderBar
